<template>
    <div class="Breadcrumbs">
        <div class="Breadcrumbs-frame u-frameMd">
            <ul>
                <li>
                    <router-link :to="'/'" class="is-active">Kalkulačka - úvod</router-link>
                </li>
                <li>
                    <router-link :to="'/'+$route.fullPath.split('/')[1]" class="is-active">{{ baseRouteName }}
                    </router-link>
                </li>
                <li v-for="(step, index) of settings" :key="index">
                    <a @click="$emit('stepChange', index)" v-if="index <= current" class="is-active">{{ step.title }}</a>
                    <a v-else>{{ step.title }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {computed} from 'vue';
import {useRoute, useRouter} from 'vue-router';

export default {
    props: {
        current: Number,
        settings: Array,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();

        const baseRouteName = computed(() => {
            return Array.from(router.options.routes).find(r => {
                return r.path.split('/')[1] === route.path.split('/')[1]
            }).meta.title;
        });

        return {
            baseRouteName
        }
    }
}
</script>

<style lang="scss" scoped>
.Breadcrumbs {
    margin: -.5em 0 2em;

    ul {
        display: flex;
        margin: 0;
        padding: 0;
        flex-wrap: wrap;
        list-style: none;

        li {
            margin-right: .2em;
            margin-bottom: .2em;
            flex: auto;

            &:last-child {
                margin-right: 0;

                a:after {
                    display: none;
                }
            }
        }

        a {
            color: inherit;
            text-decoration: none;
            background: var(--colorBrandLighten);
            display: block;
            padding: 0.7em 1.6em;
            font-size: 0.91em;
            position: relative;
            transition: all .25s ease-in-out;
            @media (max-width: 500px) {
                padding: 0.4em 1.3em;
                font-size: 0.8em;
            }

            &:after {
                content: ' ';
                position: absolute;
                left: calc(100% - .78em);
                top: 50%;
                transform: rotate(45deg) translateY(-50%);
                border-right: 2px solid white;
                border-top: 2px solid white;
                width: .9em;
                height: .9em;
                background: var(--colorBrandLighten);
                z-index: 2;
                transition: all .25s ease-in-out;
            }

            &.is-active {
                background: var(--colorBrandSecondary);
                color: #fff;
                cursor: pointer;

                &:after {
                    background: var(--colorBrandSecondary);
                }

                &:hover {
                    background: var(--colorBrandSecondaryDarken);

                    &:after {
                        background: var(--colorBrandSecondaryDarken);
                    }
                }
            }
        }
    }
}
</style>